// invitation flag feature
export const ENABLE_SHIFT_TIME_RECEPTION = false;
export const ENABLE_ANNOUNCEMENT_MODE = true;
export const ENABLE_PARTNER_MODE = false;
export const ENABLE_LIST_GUEST = true;

// Giftcard flag feature
export const ENABLE_SEND_GIFT = true;
export const ENABLE_BANK_TRANSFER = true;
export const ENABLE_GIFT_CONFIRMATION = true;

// generator link flag feature
export const DISABLE_CUSTOM_LINK = false;
export const DISABLE_GENERATOR_INVITATION = false;
export const DISABLED_QR_GENERATOR_IN_PRODUCTION = true;
export const ENABLE_BLACK_AND_WHITE = false;
export const ENABLE_DUAL_PHOTO = false;

// Global feature invitation
export const DISABLED_MUSIC_IN_DEVELOPMENT = true;
export const DEFAULT_LANGUAGE = 'id'; // change to `en` if you want to set default to English
export const ENABLE_MULTI_LANGUAGE = false;
export const ENABLE_QR_INVITATION = true;
export const ENABLE_LIVE_STREAMING = true;
export const ENABLE_GIFT_CARD = true;
export const ENABLE_DARKMODE_NOTIFICATION = true;
export const ENABLE_MUSIC_BACKSOUND = true;
export const ENABLE_LOVE_STORY = false;
export const ENABLE_RSVP = true;
export const ENABLE_COVID_PROTOCOL = false;
export const ENABLE_COVID_POPUP = false;
export const ENABLE_IG_FILTER = true;
export const ENABLE_DRESS_CODE = false;
